import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)(() => ({
  backgroundColor: "#E6EEF6",
  borderRadius: "12px",
  padding: "16px 24px",
}));

export const Header = styled(Grid)(() => ({}));

export const Title = styled("span")(() => ({
  font: "600 16px/24px Manrope",
  color: "#475467",
}));

export const Spacer = styled(Grid)(() => ({
  marginBottom: "24px", // marginBottom: "32px",
}));

export const Content = styled(Grid)(() => ({}));

export const Divider = styled("div")(() => ({
  borderBottom: "1px solid #D0D5DD",
  margin: "18px 0px",
}));
